import { Stack } from '@ekhodealer/ekho-common/rev';

import BillingContact from './BillingContact';
import PlanSummary from './PlanSummary';
import ServiceFee from './ServiceFee';

const PlanDetailsWrapper = () => {
	return (
		<Stack itemsSpacing='16'>
			<PlanSummary />
			<ServiceFee />
			<BillingContact />
		</Stack>
	);
};

export default PlanDetailsWrapper;
